var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDottedLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2,
    height: 29,
    viewBox: "0 0 2 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 2.18557e-08L0.5 1.03571L1.5 1.03571L1.5 -2.18557e-08L0.5 2.18557e-08ZM0.5 3.10714L0.5 5.17857L1.5 5.17857L1.5 3.10714L0.5 3.10714ZM0.5 7.25L0.5 9.32143L1.5 9.32143L1.5 7.25L0.5 7.25ZM0.5 11.3929L0.500001 13.4643L1.5 13.4643L1.5 11.3929L0.5 11.3929ZM0.500001 15.5357L0.500001 17.6071L1.5 17.6071L1.5 15.5357L0.500001 15.5357ZM0.500001 19.6786L0.500001 21.75L1.5 21.75L1.5 19.6786L0.500001 19.6786ZM0.500001 23.8214L0.500001 25.8929L1.5 25.8929L1.5 23.8214L0.500001 23.8214ZM0.500001 27.9643L0.500001 29L1.5 29L1.5 27.9643L0.500001 27.9643Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDottedLine);
export default __webpack_public_path__ + "static/media/dottedLine.4736e3f1.svg";
export { ForwardRef as ReactComponent };